(ns frontend.view.components.form.components.form-currency
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [common.currencies :as currencies]
   [frontend.bootstrap.components :as rbs]                  ;; TODO should be passed down
   [frontend.db :as db]
   [frontend.utils :as utils]
   [frontend.view.components.form.components.form-cancel-button :as cancel-button]
   [frontend.view.components.form.components.form-label :as form-label]
   [reagent.core :as r]))

(defonce currencies currencies/currencies)
;;TODO move to utils

(def tenant (r/cursor db/app-state [:session :tenant]))     ;; TODO should be passed as props

(defn currency-selector
  [& _]
  (let [open-dropdown (r/atom false)
        focus-state (atom {})]
    (fn [{:keys [control-id value--sym read-only? on-change--sym! on-submit!]}]
      (let [tenant-settings {:default-currency (some->> (:tenant/default-currency @tenant)
                                                        (currencies/get-label))
                             :multiplier       (or (:tenant/cur-multiplier @tenant) "k")
                             ;; used when value--sym and default currency are not defined
                             :default          [:usd "USD"]}

            currency-to-use (cond
                              (keyword? value--sym) (currencies/get-label value--sym)
                              (-> tenant-settings
                                  :default-currency)
                              (-> tenant-settings
                                  :default-currency)
                              (-> tenant-settings
                                  :default
                                  last)
                              (-> tenant-settings
                                  :default
                                  last))]
        [:span.form__currency-symbol
         {:on-click (without-default-action-and-propagation
                     (reset! open-dropdown true))}
         (str " (" currency-to-use)

         (str ")")
         [:i.fal.fa-caret-down.no-margin]
         (when (and (not read-only?) @open-dropdown)
           [:select.form__currency-select
            {:value     currency-to-use
             :ref       (fn [dom-ref]
                          (when (and dom-ref
                                     (not= dom-ref (:dom-ref @focus-state)))
                            (swap! focus-state assoc :dom-ref dom-ref)
                            (.focus dom-ref)))
             :size      5
             :id        (str control-id "--currency")
             :disabled  (boolean read-only?)
             :on-blur   (fn [e]
                          (reset! open-dropdown false))
             :on-change (fn [e]
                          (on-change--sym! (utils/get-cur-key (-> e
                                                                  .-target
                                                                  .-value)))
                          (on-submit! e)
                          (-> e
                              .-target
                              .blur)
                          (.preventDefault e)
                          (.stopPropagation e))
             :on-click  (without-default-action-and-propagation identity)}
            (doall (for [[_ v] currencies/currencies]
                     [:option
                      {:key   v
                       :value v}
                      v]))])]))))

(defn view
  [& view-args]
  (let [raw-input (r/atom nil)
        decimals (r/atom nil)
        negative? (r/atom false)
        has-focus (r/atom false)
        tenant-settings {:default-currency (:tenant/default-currency @tenant)
                         :multiplier       (or (:tenant/cur-multiplier @tenant) "k")
                         ;; used when value--sym and default currency are not defined
                         :default          [:usd "USD"]}
        base-multiplier (:tenant/cur-multiplier @tenant)]
    (fn [{:keys [size value value--sym wrapper control-id read-only?
                 on-change! on-change--sym! on-submit! on-cancel!]
          :as   view-args}]
      (let [on-cancel! (fn [e]
                         (reset! raw-input nil)
                         (on-cancel! e))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 13)
                               (-> e
                                   .-target
                                   .blur))    ;; Enter = blur -> save
                             (when (= key 27) ;; Esc = cancel
                               (on-cancel! e)
                               (-> e
                                   .-target
                                   .blur))))
            submit-value-change (fn [e]
                                  (when @raw-input
                                    (on-change! (if (or (= "" @raw-input) (js/isNaN @raw-input))
                                                  nil                                     ; remove existing value
                                                  (utils/str->bigdec (str @raw-input))))) ;; new value as bigdec
                                  (when (nil? value--sym)
                                    ;; When the value is changed for the first time, it also updates currency
                                    ;; else after changing default currency in settings,
                                    ;; this currency also changes if user never changed it manually
                                    (on-change--sym! (or (-> tenant-settings
                                                             :default-currency)
                                                         (-> tenant-settings
                                                             :default
                                                             first))))
                                  (on-submit! e))]
        [rbs/Form
         {:class-name "form-currency-form"
          :on-submit  submit-value-change
          :on-blur    (fn [e]
                        (let [targetType (-> e
                                             .-target
                                             .-nodeName)]
                          (if (= targetType "INPUT")
                            (submit-value-change e)
                            (on-cancel! e))))}
         [rbs/FormGroup
          {:control-id control-id
           :size       size
           :class-name (str wrapper " form__text")}
          [form-label/view
           (merge view-args
                  {:extra-builder (fn []
                                    [currency-selector view-args])})]
          [rbs/InputGroup
           [:input
            {:placeholder ""
             :type        "text"
             :id          control-id
             :class-name  "form-control"
             :disabled    (boolean read-only?)
             :on-blur     #(reset! has-focus false)
             :on-focus    (fn [_]
                            (reset! has-focus true)
                            (reset! raw-input nil)
                            (reset! decimals -1)
                            (reset! negative? false))
             :value       (if-not @has-focus
                            (utils/format-number-with-mult value base-multiplier)
                            (let [draw-value (if (nil? @raw-input) value @raw-input)
                                  min-decimal-count (if (nil? @raw-input) -1 @decimals)]
                              (or
                               (when draw-value
                                 (if (= draw-value "")
                                   (when @negative? "-")
                                   (utils/format-with-separators draw-value
                                                                 min-decimal-count
                                                                 @negative?))) ;; append decimal when editing without decimals
                               "")))
             :on-key-down on-key-down!
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)
                                  float-value (utils/parse-float-info input "")]
                              (reset! decimals (or (:decimal-count float-value) -1))
                              (reset! negative? (or (:negative? float-value) false))
                              (reset! raw-input (:float-value float-value))))}]
           (when @has-focus
             [cancel-button/view on-cancel!])]]]))))
